export default "__VITE_ASSET__Bo2VOUhN__"